var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-area"},[_vm._v(" "+_vm._s(_vm.textVal || "无")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }